import { Divider } from "@material-ui/core";
import React from "react";
import styled from "styled-components";
import UserLookupFormik from "../userLookup/UserLookupFormik";
import UserLookupChip from "../userLookup/UserLookupChip";

const Container = styled.div`
    width:100%
    padding:20px;
    display:grid;
    grid-template-columns:40px 350px 60px 250px;
    align-items:center;
    padding-top:30px;
    
`;

const ContainerProxies = styled.div`
    width:100%
    // padding:20px;
    padding-left:390px;
    display:grid;
    grid-template-columns:60px 250px 250px 250px;
    align-items:center;
    padding-top:30px;
    
`;
const ContainerProxiesIWPP = styled.div`
    width:100%
    // padding:20px;
    display:grid;
     padding-left:390px;
    grid-template-columns:60px 250px 250px 250px;
    align-items:center;
    padding-top:30px;
    
`;

const StepCount = styled.div`
  text-align: center;
  color: white;
  border-radius: 50%;
  height: 25px;
  line-height: 25px;
  background: gray;
  width: 25px;
`;

const StepCountContainer = styled.div`
  display: flex;
  align-items: center;
  align-content: center;
`;

const StepLabelContainer = styled.div``;

const Primary = styled.div``;

const Proxy = styled.div``;

const AssignedByProjectLabel = styled.div`
  font-style: italic;
  color: gray;
`;

const ProjectWorkflowStep = ({
  arrayHelpers,
  index,
  formProps,
  editable,
  isGbu,
}) => {
  let workflowstep = formProps.values.workflowSteps[index];
  const { primary, stepLabel, stepScope } = workflowstep;

  const assignedByProject = isGbu && stepScope === "PROJECT";
  let proxy = workflowstep.proxy;
  if (workflowstep.proxy) {
    formProps.values.workflowSteps[index].proxy = workflowstep.proxy.filter(
      function (p) {
        return p != null;
      }
    );
    workflowstep = formProps.values.workflowSteps[index];
    proxy = workflowstep.proxy;
  }
  if (proxy === null) {
    proxy = [];
  }

  return (
    <>
      <Container key={index}>
        <StepCountContainer>
          <StepCount style={{ background: editable ? "#00bcd4" : "#9e9e9e" }}>
            {index + 1}
          </StepCount>
        </StepCountContainer>
        <StepLabelContainer>{stepLabel}</StepLabelContainer>
        {editable && <StepLabelContainer> {stepScope === "PROJECT" ? "*Primary:" : "Primary:"} </StepLabelContainer>}
        {editable && (
          <Primary style={{ marginLeft: 3 }}>
            <UserLookupFormik
              placeHolder="Primary Approver"
              setFieldValue={formProps.setFieldValue}
              setFieldTouched={formProps.setFieldTouched}
              field={`workflowSteps.${index}.primary`}
              searchMethod="searchAppUser"
              value={(primary && primary.bun) ? primary : ''}
            />
          </Primary>
        )}

        {!editable && primary && primary.bun && !assignedByProject && (
          <StepLabelContainer> {stepScope === "PROJECT" ? "*Primary:" : "Primary:"} </StepLabelContainer>
        )}
        {!editable && primary && primary.bun && !assignedByProject && (
          <Primary>
            <UserLookupChip user={primary} />
          </Primary>
        )}
        {assignedByProject && (
          <AssignedByProjectLabel>Assigned By Project</AssignedByProjectLabel>
        )}
        {stepScope !== "IWPP" && (
          <ContainerProxies>
            {editable && <StepLabelContainer> Proxy: </StepLabelContainer>}
            {editable && (
              <Proxy>
                <UserLookupFormik
                  placeHolder="Proxy 1"
                  setFieldValue={formProps.setFieldValue}
                  setFieldTouched={formProps.setFieldTouched}
                  field={`workflowSteps.${index}.proxy[0]`}
                  searchMethod="searchAppUser"
                  value={proxy[0]}
                />
              </Proxy>
            )}
            {editable && proxy[0] !== undefined && proxy[0] !== null && (
              <Proxy>
                <UserLookupFormik
                  placeHolder="Proxy 2"
                  setFieldValue={formProps.setFieldValue}
                  setFieldTouched={formProps.setFieldTouched}
                  field={`workflowSteps.${index}.proxy[1]`}
                  searchMethod="searchAppUser"
                  value={proxy[1]}
                />
              </Proxy>
            )}
            {editable && proxy[1] !== undefined && proxy[1] !== null && (
              <Proxy>
                <UserLookupFormik
                  placeHolder="Proxy 3"
                  setFieldValue={formProps.setFieldValue}
                  setFieldTouched={formProps.setFieldTouched}
                  field={`workflowSteps.${index}.proxy[2]`}
                  searchMethod="searchAppUser"
                  value={proxy[2]}
                />
              </Proxy>
            )}
            {!editable && proxy && proxy.length >= 1 && !assignedByProject && (
              <StepLabelContainer> Proxy: </StepLabelContainer>
            )}
            {!editable && proxy && proxy.length >= 1 && !assignedByProject && (
              <Proxy>
                <UserLookupChip user={proxy[0]} />
              </Proxy>
            )}
            {!editable && proxy && proxy.length >= 2 && !assignedByProject && (
              <Proxy>
                <UserLookupChip user={proxy[1]} />
              </Proxy>
            )}
            {!editable && proxy && proxy.length === 3 && !assignedByProject && (
              <Proxy>
                <UserLookupChip user={proxy[2]} />
              </Proxy>
            )}
          </ContainerProxies>
        )}
        {stepScope === "IWPP" && (
          <ContainerProxiesIWPP>
            {!editable && proxy && proxy.length >= 1 && !assignedByProject && (
              <StepLabelContainer> Proxy: </StepLabelContainer>
            )}
            {!editable && proxy && proxy.length >= 1 && !assignedByProject && (
              <Proxy>
                <UserLookupChip user={proxy[0]} />
              </Proxy>
            )}
            {!editable && proxy && proxy.length >= 2 && !assignedByProject && (
              <Proxy>
                <UserLookupChip user={proxy[1]} />
              </Proxy>
            )}
            {!editable && proxy && proxy.length >= 3 && !assignedByProject && (
              <Proxy>
                <UserLookupChip user={proxy[2]} />
              </Proxy>
            )}
            {!editable && proxy && proxy.length === 4 && !assignedByProject && (
              <Proxy>
                <UserLookupChip user={proxy[3]} />
              </Proxy>
            )}
          </ContainerProxiesIWPP>
        )}
      </Container>
      <Divider />
    </>
  );
};

export default ProjectWorkflowStep;
